import React from 'react';
import CopySelector from 'shared/utils/copySelector';
import AutoFormInput from '../../../../components/AutoFormInput';
import SFormInputs from 'shared/screens/LinkAccountForm/components/FormInputs';
import { styles } from '../..//styles';

const TiFormInputs = ({ handleInputChange, formValues }) => {
  return (
    <SFormInputs
      render={args => {
        const { copys } = args;
        return (
          <>
            <div style={styles.inputRow}>
              <div style={{ flex: 1 }}>
                <AutoFormInput
                  emitInput={handleInputChange('accountNumber')}
                  value={formValues.accountNumber}
                  label=" "
                  placeholder={`${CopySelector.getCopy(CopySelector.COPY_TYPES.WILDCARD, copys)} Number`}
                  type="text"
                  customClassName="transparentInput"
                  customLabelStyle={styles.customInputLabel}
                  trimInput={true}
                />
              </div>
            </div>
            <div style={styles.inputRow}>
              <div style={{ flex: 1 }}>
                <AutoFormInput
                  emitInput={handleInputChange('pin')}
                  value={formValues.pin}
                  label=" "
                  placeholder={'PIN'}
                  type="text"
                  customClassName="transparentInput"
                  customLabelStyle={styles.customInputLabel}
                />
              </div>
            </div>
          </>
        );
      }}
    />
  );
};

export default TiFormInputs;

